<template>
    <div class="dish-details-select">
        <h3>{{ data.name }}<span v-if="isRequired">{{ $t('pages.menu.required') }}</span></h3>
        <div class="dish-details-select__option"
             v-for="option in comOptions"
             :key="option.id">

            <component :is="getComponentType"
                       v-model="comModel"
                       :inputValue="option"
                       :label="option.product.name"
                       :name="radioName + data.id" />

            <span class="dish-details-select__price">{{ `+${option.price} zł` }}</span>

        </div>
    </div>
</template>

<script>
import CheckboxButton from '@/components/CheckboxButton.vue';
import RadioButton from '@/components/RadioButton.vue';
import RadioButtonWithQuantity from './RadioButtonWithQuantity.vue';
import CheckboxWithQuantity from './CheckboxWithQuantity.vue';
export default {
    components: {
        CheckboxButton,
        RadioButton,
        RadioButtonWithQuantity,
        CheckboxWithQuantity
    },
    props: {
        data: {
            type: Object,
            reqired: true,
        },
        radioName: {
            type: [String, Number],
            default: ""
        },
        value: { type: null },
    },
    data() {
        return {
            selectedItems: [],
        };
    },
    // watch: {
    //     comModel(nv) {
    //         console.log("comModel", nv);
    //     }
    // },
    computed: {
        getComponentType() {
            if (this.isCheckbox) {
                return this.hasQuantity ? 'CheckboxWithQuantity' : 'CheckboxButton';
            } else {
                return this.hasQuantity ? 'RadioButtonWithQuantity' : 'RadioButton';
            }
        },
        comOptions() {
            return this.data.options.map(o => ({
                id: o.id,
                price: o.price,
                product: o,
                quantity: o.quantity || 1,
            }));
        },
        comModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        isCheckbox() {
            return this.data.is_multiselect;
        },
        hasQuantity() {
            return this.data.is_multiple;
        },
        isRequired() {
            return this.data.is_required;
        }
    },
};
</script>


<style lang="scss" scoped>
h3 {
    display: flex;
    align-items: center;
    gap: 12px;

    margin: 0;
    padding: 0;

    span {
        color: white;
        font-size: 12px;
        background-color: red;
        border-radius: 12px;
        padding: 4px 12px;
    }
}

.dish-details-select {
    display: grid;
    gap: 12px;

    padding: 22px;

    border-radius: 20px;

    background-color: white;

    &__option {
        display: flex;

    }

    &__price {
        flex-shrink: 0;

        margin-left: auto;

        font-weight: 500;
        font-size: 16px;

        color: black;
    }
}
</style>
